
export const TOPICS_I18N_PREFIX = "features.topics.topics";

export const TOPICS_I18N_KEYS = {
  topics:                        "topics",
  topic_name:                    "topic_name",
  description:                   "description",
  topic_keywords:                "topic_keywords",
  categories:                    "categories",
  earliest_historical_data_date: "earliest_historical_data_date",
  status:                        "status",
  topic_successfully_created_within_48_hours_toast_msg:         "topic_successfully_created_within_48_hours_toast_msg",
  topic_successfully_created_within_estimated_time_toast_msg:   "topic_successfully_created_within_estimated_time_toast_msg",
  topic_successfully_updated_within_48_hours_toast_msg:         "topic_successfully_updated_within_48_hours_toast_msg",
  topic_successfully_updated_within_estimated_time_toast_msg:   "topic_successfully_updated_within_estimated_time_toast_msg",
  topic_successfully_edited_with_no_processed_needed_toast_msg: "topic_successfully_edited_with_no_processed_needed_toast_msg",
  topic_successfully_deleted_toast_msg:                         "topic_successfully_deleted_toast_msg",
  no_topic_keywords_string:                                     "no_topic_keywords_string",
  topic_creation_failure_toast_msg:                             "topic_creation_failure_toast_msg",
  file_successfully_submitted_toast_msg:                        "file_successfully_submitted_toast_msg",
  file_submit_failed_toast_msg:                                 "file_submit_failed_toast_msg",
  retrieve_uploaded_files_failure_toast_msg:                    "retrieve_uploaded_files_failure_toast_msg",
  failed_to_delete_topic_msg:                                   "failed_to_delete_topic_msg"
};


// WEBPACK FOOTER //
// ./src/features/topics/constants/i18n/Topicsi18nConstants.js